var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 36,
    viewBox: "0 0 58 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92126 15.2191L9.68675 2.60021C10.1617 1.8284 11.3457 2.10448 11.4303 3.00677L12.3033 12.3193C12.3267 12.5689 12.2498 12.8176 12.0896 13.0105L3.45105 23.4087C2.8865 24.0883 1.78125 23.6891 1.78125 22.8056V15.7138C1.78125 15.5391 1.82972 15.3679 1.92126 15.2191Z",
    fill: "#E7E0F1",
    stroke: "#873CAA",
    strokeWidth: 0.47191
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3088 11.584L53.0861 23.202C53.5285 23.9605 54.6761 23.7568 54.8304 22.8924L56.2681 14.8412C56.3108 14.6025 56.2599 14.3565 56.1259 14.1542L48.3351 2.38847C47.8325 1.62945 46.6526 1.95167 46.6056 2.8608L46.1815 11.0596C46.172 11.2431 46.2163 11.4253 46.3088 11.584Z",
    fill: "#E7E0F1",
    stroke: "#873CAA",
    strokeWidth: 0.47191
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9729 2L10.2122 2.18153V13.6492L6.08398 20H52.084L46.9729 13.6492V2Z",
    fill: "#F3EFF8",
    stroke: "#873CAA",
    strokeWidth: 0.47191
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33.1124V15.3793C1 14.3368 1.84512 13.4917 2.88764 13.4917H14.7442C15.4326 13.4917 16.0664 13.8665 16.3982 14.4696L17.4732 16.4243C17.805 17.0275 18.4388 17.4023 19.1272 17.4023H38.9623C39.7644 17.4023 40.479 16.8953 40.7439 16.1382L41.2278 14.7558C41.4928 13.9986 42.2073 13.4917 43.0095 13.4917H55.0339C56.0765 13.4917 56.9216 14.3368 56.9216 15.3793V33.1124C56.9216 34.1549 56.0765 35 55.0339 35H2.88764C1.84513 35 1 34.1549 1 33.1124Z",
    fill: "#E7E0F1",
    stroke: "#873CAA",
    strokeWidth: 0.47191
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty_box.87114d3b6fcbb4b2a77a8ddee0c676d7.svg";
export { ForwardRef as ReactComponent };